// Why Choose Section
import { MessageSquare, Cloud, X } from 'lucide-react';
import premiumDashboard from '../../../assets/premium_dashboard.png';

interface Feature {
  icon: React.ReactNode;
  text: string;
}

const features: Feature[] = [
  {
    icon: <MessageSquare className="w-6 h-6 text-white" />,
    text: 'Suporte multicanal aprovado por 95% dos clientes',
  },
  {
    icon: <Cloud className="w-6 h-6 text-white" />,
    text: 'Sistema 100% online, acesse de qualquer lugar',
  },
  {
    icon: <X className="w-6 h-6 text-white" />,
    text: 'Sem custo de ativação: é só se inscrever e começar',
  },
];

export function WhyChoose() {
  return (
    <section className="py-20 bg-white dark:bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left: Image placeholder */}
          {/* Left: Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl transform hover:scale-[1.02] transition-transform duration-300">
              <div className="absolute inset-0 bg-gradient-to-tr from-green-500/20 to-transparent z-10 pointer-events-none" />
              <img
                src={premiumDashboard}
                alt="Dashboard proNotas"
                className="w-full h-auto object-cover"
              />
            </div>
            {/* Decorative elements */}
            <div className="absolute -z-10 top-10 -left-10 w-32 h-32 bg-green-200 rounded-full blur-3xl opacity-30 animate-pulse" />
            <div className="absolute -z-10 -bottom-10 -right-10 w-40 h-40 bg-green-400 rounded-full blur-3xl opacity-20" />
          </div>

          {/* Right: Content */}
          <div className="bg-green-800 rounded-2xl p-8 md:p-12 text-white">
            <h2 className="text-3xl md:text-4xl font-bold mb-6">
              Por que escolher o proNotas?
            </h2>

            <p className="text-lg text-green-100 mb-8">
              O sistema de gestão financeira inteligente e prático que você precisa.
              Emissão de notas fiscais de qualquer tipo (produto e serviço) para qualquer lugar do Brasil.
              <strong className="text-white"> Simples, prático e rápido.</strong>
            </p>

            <div className="space-y-6">
              {features.map((feature, index) => (
                <div key={index} className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-green-600 rounded-lg flex items-center justify-center flex-shrink-0">
                    {feature.icon}
                  </div>
                  <p className="text-lg text-green-100 pt-2">{feature.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
